import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { ArcheHeader } from '../../../components/ArcheHeader';
import { MiningLandsPage } from './MiningLandsPage';
import { MiningLogPage } from './MiningLogPage';

/**
 * Arche wrapper for DFE Mining — provides ArcheLayout with sidebar
 * and handles sub-routing for mining pages.
 */
export function MiningArchePage() {
  return (
    <ArcheLayout>
      <div className="flex flex-col h-full">
        <ArcheHeader archeId="arche_dfe_mining" title="Mining" />
        <div className="flex-1 overflow-auto">
          <Routes>
            <Route path="/" element={<MiningLandsPage />} />
            <Route path="/log" element={<MiningLogPage />} />
          </Routes>
        </div>
      </div>
    </ArcheLayout>
  );
}
